<template>
  <v-menu
    top
    open-on-hover
    nudge-top="30px"
    max-width="250px"
  >
    <template v-slot:activator="{ on }">
      <div
        class="d-inline-block overflow-hidden menstrual-phases"
        v-on="on"
      >
        <div
          v-for="phase in menstrualPhases"
          :key="phase.key"
          style=""
          class="d-inline-block fill-height overflow-hidden menstrual-phases--block"
        >
          <div
            class="fill-height"
            :class="{ 'primary': currentMenstrualPhase === phase.key, 'orange darken-3': currentMenstrualPhase === phase.key && currentMenstrualPhase === 'period_overdue', 'grey lighten-3': currentMenstrualPhase !== phase.key }"
          />
        </div>
      </div>
    </template>
    <v-card>
      <v-card-text class="caption pa-2">
        <div class="mb-3">
          {{ $t('individual_analysis.menstrual_cycle_phase.phases_card.title') }}
        </div>
        <v-row
          v-for="phase in menstrualPhases"
          :key="'tooltip-' + phase.key"
          :class="{ 'font-weight-bold': currentMenstrualPhase === phase.key }"
          no-gutters
        >
          <v-col>
            {{ phase.text }}
          </v-col>
          <v-col
            v-if="phase.fromDate && phase.toDate"
            cols="5"
          >
            {{ phase.fromDate }} - {{ phase.toDate }}
          </v-col>
          <v-col
            v-else-if="phase.fromDate"
            cols="5"
          >
            {{ phase.fromDate }} - ...
          </v-col>
          <v-col
            v-else-if="phase.from && phase.to"
            cols="5"
          >
            {{ phase.from }}. - {{ phase.to }}.
          </v-col>
          <v-col
            v-else-if="phase.from"
            cols="5"
          >
            {{ phase.from }}. - ...
          </v-col>
        </v-row>
        <div
          class="grey--text mt-3"
          style="font-size: 10px"
        >
          {{ $t('individual_analysis.menstrual_cycle_phase.phases_card.info') }}
        </div>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { MenstrualPhases } from '@/data/models'
import dayjs from 'dayjs'

export default {
  name: 'MenstrualPhases',
  props: {
    currentMenstrualPhase: {
      type: String,
      default: undefined
    },
    stats: {
      type: Object,
      default: () => ({})
    }
  },
  created() {
    const keys = Object.keys(MenstrualPhases)

    const menstrualPhases = []

    let startDate = null

    startDate = dayjs(this.stats.cycle_start)

    for (const key of keys) {
      const phase = MenstrualPhases[key]

      phase.key = key
      phase.duration = this.stats[key] || 0

      if (startDate) {
        phase.fromDate = startDate.format('DD/MM')
        phase.toDate = startDate.clone().add(phase.duration - 1, 'days').format('DD/MM')

        startDate = startDate.add(phase.duration, 'days')
      }

      menstrualPhases.push(phase)
    }

    this.menstrualPhases = menstrualPhases
  }
}
</script>

<style scoped>
  .menstrual-phases {
    height: 25px;
    border-radius: 6px !important;
    cursor: pointer;
  }

  .menstrual-phases--block {
    width: 15px;
    border-right: 1px solid #e3e3e3;
  }

  .menstrual-phases--block:last-child {
    border-right: none;
  }
</style>
